import React from "react";
import ShiftExchangesManagement from "pages/ShiftExchangesManagement";

const ShiftExchangesPending = (props) => (
	<ShiftExchangesManagement {...props} mode="pending" />
);

export default ShiftExchangesPending;
